import React, { useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";
import styles from "../../stripe-dashboard.module.css";

function KPICard({
  title,
  value,
  icon,
  format = v => v,
  tooltipText,
  delta
}) {
  const [showTip, setShowTip] = useState(false);
  const hasDelta = typeof delta === "number" && Number.isFinite(delta);
  const positive = hasDelta ? delta >= 0 : false;
  const deltaText = hasDelta ? `${positive ? "↑" : "↓"} ${Math.abs(delta).toFixed(1)}%` : "";

  return (
    <div className={styles.kpiCard}>
      <div className={styles.kpiRow}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className={styles.kpiTitleRow}>
            <span className={styles.kpiLabel}>{title}</span>
            {tooltipText && (
              <span
                className={styles.tooltipIcon}
                onMouseEnter={() => setShowTip(true)}
                onMouseLeave={() => setShowTip(false)}
              >
                <FaQuestionCircle />
                {showTip && (
                  <span className={styles.tooltipBubble}>{tooltipText}</span>
                )}
              </span>
            )}
          </div>
          <p className={styles.kpiValue}>{format(value)}</p>
          {hasDelta && (
            <div
              className={`${styles.deltaBadge} ${
                positive ? styles.deltaPositive : styles.deltaNegative
              }`}
            >
              {deltaText}
            </div>
          )}
        </div>
        {icon && <div className={styles.kpiIcon}>{icon}</div>}
      </div>
    </div>
  );
}

export default KPICard;
